import { Box, Column, Text } from '~/commonComponents';
import { Colors } from '~/themes/colors';

export const PaymentDetailsPreview = () => {
  return (
    <Box gap={14}>
      <Text fontSize={22} bold>
        Payment
      </Text>

      <Box
        paddingTop={22}
        paddingBottom={32}
        paddingHorizontal={63}
        border={`1.5px solid ${Colors.neutral_100}`}
        borderRadius={8}
      >
        <Column gap={18}>
          <Box
            paddingTop={22}
            paddingBottom={32}
            paddingHorizontal={37}
            border={`1.5px solid ${Colors.neutral_100}`}
            borderRadius={8}
          >
            <Text bold>Please Note</Text>
            <Column paddingLeft={8}>
              <Text>
                • Working interviews will incur a separate fee once candidates are{' '}
                <Text bold>confirmed</Text> by your office.
              </Text>
              <Text>
                • You can always post more working interviews for this job later from the
                &quot;Manage Jobs&quot; page.
              </Text>
              <Text>
                • Your job posting is valid for 30 days and will <Text bold>auto-renew</Text> unless
                you deactivate it.
              </Text>
            </Column>
          </Box>

          <Box
            backgroundColor={Colors.neutral_50}
            borderRadius={3}
            paddingVertical={12}
            paddingHorizontal={17}
          >
            <Text fontSize={15}>
              Your next billing date will be on Wednesday, October 15th, 2025 for $99.95.
            </Text>
          </Box>

          <Box
            paddingTop={22}
            paddingBottom={32}
            paddingHorizontal={25}
            boxShadow="0 2px 4px rgba(0, 0, 0, 0.15), 0 2px 4px rgba(0, 0, 0, 0.15)"
            borderRadius={10}
          >
            <Text fontSize={18} bold color="secondary_500">
              30-Day Job Posting
            </Text>
            <Text fontSize={14}>
              <Text fontSize={36} bold>
                $99.95
              </Text>{' '}
              billed every 30 days
            </Text>
            <Text fontSize={15} italic marginTop={12}>
              Your job will be active and visible to candidates.
            </Text>
          </Box>
        </Column>
      </Box>
    </Box>
  );
};
